export interface Size {
    width: number;
    height: number;
}

export interface Point {
    x: number;
    y: number;
}

export interface Bounds {
    left: number;
    top: number;
    width: number;
    height: number;
}

export interface ScrollOptions {
    smooth: boolean;
    center: true;
    block: Block
}

export enum Block {
    START = "start",
    CENTER = "center",
    END = "end",
    NEAREST = "nearest"
}
